import { arrayUnion, doc, writeBatch } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import {
	getOrganizationFirestore,
	getOrganizationStorage,
} from '../resources/orgFirebase';

export default class FileItemManager {
	static signUserDocument(orgData, userId, fileId, fileData, completedFile) {
		return new Promise((resolve, reject) => {
			const firestore = getOrganizationFirestore(orgData);
			const storage = getOrganizationStorage(orgData);
			const userRef = doc(firestore, `users/${userId}`);
			const userFileRef = doc(firestore, `${userRef.path}/files/${fileId}`);
			const userFileStorageRef = ref(storage, `${userFileRef.path}`);

			uploadBytes(userFileStorageRef, completedFile)
				.then((snapshot) => {
					getDownloadURL(snapshot.ref)
						.then((downloadURL) => {
							const batch = writeBatch(firestore);

							var userFileData = {
								fileId: fileId,
								fileTitle: fileData.fileTitle,
								fileContentType: fileData.fileContentType,
								fileSignedLink: downloadURL,
								timestamp: new Date(),
							};

							batch.set(userFileRef, userFileData);
							batch.set(userRef, { files: arrayUnion(fileId) }, { merge: true });

							batch
								.commit()
								.then(() => {
									return resolve(downloadURL);
								})
								.catch((error) => {
									return reject(error.message);
								});
						})
						.catch((error) => {
							return reject(error.message);
						});
				})
				.catch((error) => {
					return reject(error.message);
				});
		});
	}
}
